import { useFlags as useFlagsOriginal } from "launchdarkly-react-client-sdk";

let stubbedFlags = null;
let stubbedFlagsFunction = null;

export const useFlags = () => {
  const actualFlags = useFlagsOriginal();
  if (stubbedFlags != null) {
    return stubbedFlags;
  } else if (stubbedFlagsFunction != null) {
    return stubbedFlagsFunction();
  } else {
    return actualFlags;
  }
};

export const stubFlags = (flags: { [key: string]: any } = null) => {
  stubbedFlags = flags;
  stubbedFlagsFunction = null;
};

export const stubFlagsFunction = (func: () => { [key: string]: any }) => {
  stubbedFlagsFunction = func;
  stubbedFlags = null;
};
